/**
 * The studio footer's standard look (the prototype's site footer, for a guest).
 * Draws the behavior half's state and calls its actions; holds no rule.
 */

import { partsOf, pieceRoot } from '../../contract/runtime';
import { onLink } from '../../ui/onLink';
import shared from '../../styles/shared.module.css';
import type { StudioFooterRuntime } from './useStudioFooter';
import css from './StudioFooter.module.css';
import { contract } from './contract';

const part = partsOf(contract);

export function StudioFooterView({ state, actions, options }: StudioFooterRuntime) {
  const showLinks = state.links.length > 0;
  const showFindUs = options.showFindUs && state.location !== null;
  const showAccount = state.account.length > 0;
  const cols = 1 + Number(showLinks) + Number(showAccount) + Number(showFindUs);
  return (
    <footer className={css.footer} {...pieceRoot(contract)} {...part('footer')}>
      <div className={`${shared.wrap} ${css.grid} ${cols === 4 ? css.cols4 : cols === 3 ? css.cols3 : cols === 2 ? css.cols2 : ''}`}>
        <div {...part('brand')}>
          <a className={css.mark} href="/" onClick={onLink(actions.goHome)} {...part('mark')}>
            {state.logoUrl && <img className={css.logo} src={state.logoUrl} alt="" {...part('logo')} />}
            <span className={`${css.name} ${state.logoUrl ? '' : css.wordmark}`} {...part('name')}>
              {state.name}
            </span>
          </a>
          {state.blurb && (
            <p className={css.blurb} {...part('blurb')}>
              {state.blurb}
            </p>
          )}
        </div>
        {showLinks && (
          <div {...part('links')}>
            {options.linksHeading && (
              <div className={css.head} {...part('linksHeading')}>
                {options.linksHeading}
              </div>
            )}
            <ul className={css.list}>
              {state.links.map((l) => (
                <li key={l.id}>
                  <a href={l.href} onClick={onLink(() => actions.open(l.id))} {...part('link')}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
        {showAccount && (
          <div {...part('account')}>
            {options.accountHeading && (
              <div className={css.head} {...part('accountHeading')}>
                {options.accountHeading}
              </div>
            )}
            <ul className={css.list}>
              {state.account.map((l) => (
                <li key={l.id}>
                  {l.href ? (
                    <a href={l.href} onClick={onLink(() => actions.openAccount(l.id))} {...part('accountLink')}>
                      {l.label}
                    </a>
                  ) : (
                    <button type="button" className={css.linkButton} onClick={() => actions.openAccount(l.id)} {...part('accountLink')}>
                      {l.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
        {showFindUs && (
          <div {...part('findUs')}>
            {options.findUsHeading && (
              <div className={css.head} {...part('findUsHeading')}>
                {options.findUsHeading}
              </div>
            )}
            <ul className={css.list}>
              <li {...part('findUsName')}>{state.name}</li>
              <li {...part('location')}>{state.location}</li>
            </ul>
          </div>
        )}
        <div className={css.small} {...part('small')}>
          © {state.year} {state.name}
        </div>
      </div>
    </footer>
  );
}
